const translations = {
    deleteFlightLogErrorMessage:
        'Unable to delete flights that contain a combination of synced and uploaded data.',
    deleteFlightLogErrorTitle: 'Cannot Delete Selected Flights'
};

export default translations;
